import { useHttpClientContext } from '@/shared/context/HttpClientContext';
import {
    GetWeighingNoteBillingStatusParams,
    GetWeighingNoteBillingStatusResponseSchema,
} from './types/WeighingNoteBilling';

export const useGetWeighingNoteBillingStatusApi = () => {
    const { monolithClient } = useHttpClientContext();
    return {
        getWeighingNoteBillingStatus: async (params: GetWeighingNoteBillingStatusParams) =>
            monolithClient
                .get(`/finance/v1/platform/weighing-notes/billing-occurrences`, { params })
                .then(response => GetWeighingNoteBillingStatusResponseSchema.parse(response.data)),
    };
};
